<template>
  <div>
    <div v-if="!sellOff" class="wrapper-sell-off-form">
      <v-form ref="form">
        <div class="d-flex align-center">
          <v-text-field
              class="selloff-label"
              v-model="sellOffLabel"
              dense
              outlined
              :label="'label_selloff'|globalTranslate"
              :rules="labelRules"
              validate-on-blur
          ></v-text-field>
          <v-btn class="mb-7 ml-3" id="add-sell-off" depressed color="primary" v-on:click="addSellOff">OK</v-btn>
        </div>
      </v-form>
    </div>
    <div v-else class="wrapper-sell-off-info">
      Vous bénéficiez de {{ sellOff.percent }}% de réduction supplémentaire
      <v-chip small color="deep-purple accent-4" outlined class="remove-sell-off" @click="removeSellOff">
        <v-icon small left>mdi-delete-variant</v-icon>
        {{ 'delete'|globalTranslate }}
      </v-chip>
    </div>
    <v-snackbar v-model="snackbar" timeout="2000" :top="true" :right="true" :color="snackbarColor">{{
        snackbarMsg
      }}
    </v-snackbar>
  </div>
</template>

<script>
import snackbarMixin from "@/mixins/snackbarMixin";

export default {
  name: "SellOffForm",
  computed: {
    sellOff() {
      return this.$store.state.cart.sellOff;
    }
  },
  data() {
    return {
      labelRules: [
        value => !!value || "Ce champ est requis",
        value => (value && value.length === 10) || 'La longueur du code promo est de 10 caractères',
      ],
      sellOffLabel: ""
    }
  },
  methods: {
    addSellOff() {
      if (this.validateForm()) {
        this.$store.dispatch("cart/addSellOff", this.sellOffLabel).then(sellOff => {
          if (!sellOff.active) {
            this.showSnackBar("Ce code promo n'est plus valide.", "error")
          } else {
            this.showSnackBar("Code promo ajouté !");
          }
        }).catch(() => {
          this.showSnackBar("Ce code promo n'existe pas.", "error");
        });
      } else {
        this.showSnackBar("Le code promo n'est pas valide !", "error")
      }
    },
    removeSellOff() {
      this.$store.dispatch("cart/removeSellOff");
    },
    validateForm() {
      return this.$refs.form.validate();
    }
  },
  mixins: [snackbarMixin]
}
</script>

<style scoped>
.wrapper-sell-off-form .d-flex > div {
  max-width: 250px;
}
</style>
